<template>
  <div class="add-to-cart-sidebar" :class="{active : dataShow}">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="hide">
        <span>
        &times;
        </span>
    </button>

    <div class="sidebar-content flex justify-between">
      <div class="top">
        <div class="row text-center">
          <div class="col-xs-2">
                  <i style="color:#1ABA75" class="fal fa-2x fa-cart-arrow-down"></i>
          </div>
          <div class="col-xs-10" >
            <span style="font-size: 1rem;font-weight: 400">
              {{__t('shop.cart.product_added')}}
            </span>
                  
          </div>

        </div>
         <hr>
        <div class="row">
          <div v-if="item" class="col-xs-12">
            <span style="font-size:1.5rem;font-weight: normal">
              {{item.name}}
            </span><br>
            <span v-if="variant && variant.values">
            <span class="cart-product-description" v-for="(variantValue,index) in variant.values">
              <span>
              {{variantValue.optionGroup.name}}: {{variantValue.option.name}}
              </span><br>
            </span>
            </span>
            <span v-if="options.length" class="cart-product-description">
            <span class="cart-product-description" v-for="(options,optionGroupName) in optionsByGroupName">
              <span>
              {{optionGroupName}}: {{options.map(x => x.name).join(', ')}}
              </span><br>
            </span>
            </span>


            <p style="margin-top:12px;font-size: 1.5rem;font-weight: 600">
              {{__t('shop.checkout.cart_item_price')}}: {{cost}} {{currency}}
            </p>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="row">
      <div class="col-xs-12">
        
       <div v-if="minimumPurchaseAmountEnabled && minimumPurchaseAmount > 0">
        {{ __('webapp.minimum_purchase_amount') }}: {{ minimumPurchaseAmount.toFixed(2) }}€
      </div>

        <a @click.prevent="handleCheckoutClicked" class="btn is-btn-primary btn-block">
          {{__t('shop.cart.checkout_button')}}
        </a>

        <button @click="hide" class="btn is-btn-secondary btn-block hidden">
          {{__t('shop.cart.continue_shopping')}}
        </button>

      </div>
    </div>
      </div>
    </div>




  </div>
</template>

<script>
import select2 from '@/components/ui/select2';
export default {
  components: {select2},
  data() {
    return{
      dataShow: false,
      options: [],
      variant: {},
    }
  },
  props:{
    item: Object,
    cost: [Number,String],
    currency: String,
    cartUrl : String,

    minimumPurchaseAmountEnabled: {
      type: Boolean,
      required: true
    },
    minimumPurchaseAmount: {
      type: Number,
      required: true
    },
  },
  computed:{
    optionsByGroupName(){
          return this.$_.groupBy(this.options,function(b){return b.optionGroup.name})
    }
  },
  methods:{
    setVariant(variant){
      this.variant = variant;
    },
    setOptions(options){
      this.options = options;
    },
    show(){
      this.dataShow = true;
    },
    hide(){
      this.dataShow = false;
    },
    flash(seconds = 6){
      this.dataShow = true;
      setTimeout(() => {
        this.dataShow = false
      },seconds * 1000);
    },
     handleCheckoutClicked(){
          $.ajax({
            type: 'POST',
            url: route('webapp.shop.checkout.create',{alias: window.company_alias}),
            data: {},
            success(response){
              console.log(response)
              if(response.hasOwnProperty('redirect')){
                window.location.href = response.redirect;
              }
            },
            error(error){
              console.log(error)
            }
          })
        }
  }
}
</script>

<style scoped>

.size28{
  font-size: 28px;
}

hr {
	background-color: #eee;
	height: 1px;
	padding: 0px;
}

.size32{
  font-size: 32px;
}

.add-to-cart-sidebar.active{
  right: 0;
}

.add-to-cart-sidebar button.close{
  float:left;
  position: absolute;
}

.add-to-cart-sidebar .top,
.add-to-cart-sidebar .bottom{
  width: 100%;
}

.add-to-cart-sidebar .sidebar-content{
  height:100%;
  flex-direction: column;
  padding-top:40px;
  padding-bottom:40px;
}
.add-to-cart-sidebar{
  position: fixed;
  padding: 24px;
  top: 0;
  z-index: 21;
  right: -350px;
  height: 100%;
  min-width: 350px;
  max-width: 350px;
  background: #EFF3F7;
  color: #000;
  transition: all 0.3s;
  border-left: 1px solid #E8E8E8;
}
</style>